import type { CartProductConfiguration, ConfiguredComboComponentInput, ConfiguredProductInput } from './types';

export const MAX_CART_LINES = 50;
export const MAX_CART_LINE_QUANTITY = 20;

function normalizeConfiguredProduct(configuration: ConfiguredProductInput): ConfiguredProductInput {
  return {
    productId: configuration.productId,
    variantId: configuration.variantId ?? null,
    groups: configuration.groups
      .map((group) => ({
        groupId: group.groupId,
        options: group.options
          .filter((option) => Number.isInteger(option.quantity) && option.quantity > 0)
          .map((option) => ({ optionId: option.optionId, quantity: option.quantity }))
          .sort((a, b) => a.optionId.localeCompare(b.optionId)),
      }))
      .filter((group) => group.options.length > 0)
      .sort((a, b) => a.groupId.localeCompare(b.groupId)),
    excludedIngredientIds: [...new Set(configuration.excludedIngredientIds)].sort(),
    includedIngredientIds: [...new Set(configuration.includedIngredientIds)].sort(),
  };
}

function normalizeComboComponents(comboComponents: ConfiguredComboComponentInput[]): ConfiguredComboComponentInput[] {
  return comboComponents
    .map((component) => ({
      componentId: component.componentId,
      units: component.units
        .map(normalizeConfiguredProduct)
        .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b))),
    }))
    .sort((a, b) => a.componentId.localeCompare(b.componentId));
}

export function normalizeCartConfiguration(configuration: CartProductConfiguration): CartProductConfiguration {
  const base = normalizeConfiguredProduct(configuration);
  return {
    ...base,
    comboComponents: normalizeComboComponents(configuration.comboComponents),
  };
}

export function cartLineId(configuration: CartProductConfiguration): string {
  return `${configuration.productId}:${JSON.stringify(normalizeCartConfiguration(configuration))}`;
}
